'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _ChartLegend = require('./ChartLegend');

var _ChartLegend2 = _interopRequireDefault(_ChartLegend);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _ChartLegend2.default;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/ChartLegend/index.js
// module id = 554
// module chunks = 11